export const COUPON_REPORT = 'COUPON_REPORT';
export const POS_PROVIDER = 'pos';
